
import { useState, useEffect } from 'react';

export const useUserPoints = (userId?: string) => {
  const [points, setPoints] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserPoints = async () => {
      if (!userId) {
        setIsLoading(false);
        return;
      }

      try {
        // Mock data - in a real app, this would be an API call
        // Simulate an API delay
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // Generate random points between 100 and 1000
        const mockPoints = Math.floor(100 + Math.random() * 900);
        setPoints(mockPoints);
      } catch (error) {
        console.error('Error fetching user points:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserPoints();
  }, [userId]);

  return { points, isLoading };
};
